module.exports = __webpack_public_path__ + "img/2@s.20fd5595.jpg";